// extracted by mini-css-extract-plugin
export var icon = "_bn-3";
export var subtitle = "_bn-2";
export var title = "_bn-1";
export var value = "_bn-0";